import { Dropdown, Input, Table } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { setFolderObj } from "../../../features/folder/folderSlice";
import toast from "react-hot-toast";
import svg27 from "../../../assets/svg/svg27.svg";
import DeleteModal from "../../../components/DeleteModal";
import AddNextOfKinModal from "./modal/AddNextOfKinModal";
import { disconnectUser } from "../../../features/dependant/dependantSlice";
import NoDataTable from "../../../components/NoDataTable";
import {
  fetchConnectedUser,
  fetchThirdPartyUser,
} from "../../../features/dropdown/dropdownSlice";

export default function ThirdPartyUsersTable({ folderObj }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { fldLoading, deleteLoading, refetch, refetchKey } = useSelector(
    (state) => state.folder
  );

  const { connectedUserData, NoKCount, loading } = useSelector(
    (state) => state.dropdown
  );
  const [searchText, setSearchText] = useState("");
  const [search, setsearch] = useState("");

  const [open, setopen] = useState(false);

  function handleCancel() {
    setopen(false);
  }

  const [prodd, setProdd] = useState("");
  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const showModalDelete = async () => {
    setIsModalOpenDelete(true);
  };
  const handleDelete = async () => {
    const res = await dispatch(
      disconnectUser({
        usrId: prodd?.usrId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await fetchConnectedUserData();
      await setIsModalOpenDelete(false);
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const handleAddThirdParty = async () => {
    await setopen(true);
    await setProdd("");
  };

  const handleEdit = () => {
    setopen(true);
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <div
          onClick={showModalDelete}
          className="flex  text-[16px] font-sans   !text-lightBlack"
        >
          Disconnect
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "Staff No",
      sorter: (a, b) => a.usrPersId.localeCompare(b.usrPersId),
      dataIndex: "usrPersId",
    },
    {
      title: "first Name",
      dataIndex: "usrFirstName",
      sorter: (a, b) => a.usrFirstName.localeCompare(b.usrFirstName),
    },
    {
      title: "Last Name",
      dataIndex: "usrLastName",
      sorter: (a, b) => a.usrLastName.localeCompare(b.usrLastName),
    },
    {
      title: "Username",
      dataIndex: "usrUsername",
      sorter: (a, b) => a.usrUsername.localeCompare(b.usrUsername),
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const filteredData = searchText
    ? connectedUserData?.filter((item) =>
        item?.nkFullname?.toLowerCase().includes(searchText.toLowerCase())
      )
    : connectedUserData;

  async function fetchThirdPartyUsersData() {
    await dispatch(fetchThirdPartyUser("199"));
  }

  async function fetchConnectedUserData() {
    await dispatch(fetchConnectedUser({ ppId: folderObj?.ppId }));
  }

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    if (refetchKey == 5) {
      fetchThirdPartyUsersData();
      fetchConnectedUserData();
    }
  }, [refetchKey, refetch]);
  return (
    <>
      {connectedUserData && connectedUserData?.length > 0 ? (
        <>
          <div className="flex flex-col  w-full">
            <h3 className="font-[700] text-[24px] text-lightBlack dash-title mt-[1.25rem]">
              Connected User Details
            </h3>
            <div className="mt-5 flex lg:flex-row flex-col gap-y-5 justify-between lg:items-center items-start w-full">
              <div className="flex items-center w-full ">
                <Input
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  placeholder="Search dependant name or keyword"
                  className="text-[16px] font-[400] flex-row-reverse search-input"
                  prefix={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M11.2508 3.75C7.50609 3.75 4.47041 6.93997 4.47041 10.875C4.47041 14.81 7.50609 18 11.2508 18C14.9955 18 18.0312 14.81 18.0312 10.875C18.0312 6.93997 14.9955 3.75 11.2508 3.75ZM3.04297 10.875C3.04297 6.11154 6.71773 2.25 11.2508 2.25C15.7838 2.25 19.4586 6.11154 19.4586 10.875C19.4586 15.6385 15.7838 19.5 11.2508 19.5C6.71773 19.5 3.04297 15.6385 3.04297 10.875Z"
                        fill="#333333"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M16.045 15.913C16.3237 15.6201 16.7756 15.6201 17.0543 15.913L21.3902 20.4693C21.6689 20.7622 21.6689 21.237 21.3902 21.5299C21.1115 21.8228 20.6596 21.8228 20.3809 21.5299L16.045 16.9737C15.7663 16.6808 15.7663 16.2059 16.045 15.913Z"
                        fill="#333333"
                      />
                    </svg>
                  }
                />
              </div>
            </div>
          </div>

          <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
            <section>
              <Table
                rowSelection={false}
                className="mt-[1.31rem] w-full"
                scroll={{
                  x: 800,
                }}
                rowKey={(record) => record?.usrId}
                columns={columns}
                dataSource={filteredData}
                loading={fldLoading}
                pagination={{
                  position: ["bottomCenter"],
                  current: pageIndex + 1,
                  pageSize: pageSize,
                  onChange: (page, size) => {
                    setPageIndex(page - 1);
                    setPageSize(size);
                    fetchConnectedUserData(page - 1, size);
                  },
                  showSizeChanger: false,
                  hideOnSinglePage: true,
                }}
              />
            </section>
          </div>
        </>
      ) : (
        <NoDataTable
          title="Connect Current Personel to users In Other systems e.g Billing"
          imgTitle="Create NOK entry to organise your next of kins"
          btnTile="Join To Users"
          handleAddFolder={handleAddThirdParty}
        />
      )}

      <DeleteModal
        isModalOpen={isModalOpenDelete}
        setIsModalOpen={setIsModalOpenDelete}
        prodd={prodd}
        handleDelete={handleDelete}
        loading={loading}
        content={`Are you sure you want to disconnect ${prodd?.usrFirstName}?`}
        title={`dicsonnect ${prodd?.usrFirstName}`}
      />

      <AddNextOfKinModal
        handleFetchData={fetchConnectedUserData}
        open={open}
        handleCancel={handleCancel}
        prodd={prodd}
        folderObj={folderObj}
      />
    </>
  );
}
